"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setWidgetName = void 0;
const command_manager_1 = require("../../command_manager");
const model_1 = require("../../model");
const store_1 = require("../../exports/store");
const types_1 = require("../../types");
exports.setWidgetName = {
    undoable: false,
    execute(context, options) {
        const state = context.model;
        const { resourceId, newWidgetName } = options;
        const widgetPack = store_1.Selectors.getResourcePack(state, resourceId, types_1.ResourceType.Widget);
        if (!widgetPack) {
            return null;
        }
        const widgetSnapshot = widgetPack.widget.snapshot;
        const setWidgetNameAction = model_1.WidgetActions.setWidgetName2Action(widgetSnapshot, { newWidgetName });
        if (!setWidgetNameAction) {
            return null;
        }
        return {
            resourceId: resourceId,
            resourceType: options.resourceType,
            result: command_manager_1.ExecuteResult.Success,
            actions: setWidgetNameAction,
        };
    },
};
//# sourceMappingURL=set_widget_name.js.map